<div *ngIf="currentCity" class="container-large">
    <div class="section-header">
        <h2 class="section-title">{{word[language].searchByCuisine}}</h2>
    </div>
    <div class="section-body">
       <!-- <div *ngIf="city == 'sofia' || city=='plovdiv'">temp</div> -->

<div class="new-section food-type" *ngIf="this.city == 'sofia'">
  <div class="food-category-box">
      <a title="{{this.word[this.language].fineDining}}, {{this.word[this.language].restaurants}}"
         [routerLink]="'/' + language == 'en' ? language + '/' + 'fine.dining_435/1' : 'fine.dining_435/1'">

          <p class="food-category-title">{{this.word[this.language].fineDining}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/fineDiningLarge.jpg"
              srcset="assets/images/foodTypes/fineDiningSmall.jpg 992w, assets/images/foodTypes/fineDiningLarge.jpg 2000w"
              alt="{{this.word[this.language].fineDining}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].fineDining}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].european}} {{this.word[this.language].kitchen}}"
         [routerLink]="'/' + language == 'en' ? language + '/' + 'evropeiska_54/1' : 'evropeiska_54/1'" >
          <p class="food-category-title">{{this.word[this.language].european}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/europeanLarge.jpg"
              srcset="assets/images/foodTypes/europeanSmall.jpg 992w, assets/images/foodTypes/europeanLarge.jpg 2000w"
              alt="{{this.word[this.language].european}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].european}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].grill}}, {{this.word[this.language].zavedenia}}"
         [routerLink]="'/' + language == 'en' ? language + '/' + 'skara.bbq_66/1' : 'skara.bbq_66/1'">
          <p class="food-category-title">{{this.word[this.language].grill}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/barbecueLarge.jpg"
              srcset="assets/images/foodTypes/barbecueSmall.jpg 992w, assets/images/foodTypes/barbecueLarge.jpg 2000w"
              alt="{{this.word[this.language].grill}}, {{this.word[this.language].zavedenia}}" title="{{this.word[this.language].grill}}, {{this.word[this.language].zavedenia}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].italian}} {{this.word[this.language].kitchen}}"
         [routerLink]="'/' + language == 'en' ? language + '/' + 'italianska.kuhnia_46/1' : 'italianska.kuhnia_46/1'">
          <p class="food-category-title">{{this.word[this.language].italian}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/italianLarge.jpg"
              srcset="assets/images/foodTypes/italianSmall.jpg 992w, assets/images/foodTypes/italianLarge.jpg 2000w"
              alt="{{this.word[this.language].italian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].italian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].asian}} {{this.word[this.language].kitchen}}"
         [routerLink]="'/' + language == 'en' ? language + '/' + 'aziatska.kuhnia_377/1' : 'aziatska.kuhnia_377/1'">
          <p class="food-category-title">{{this.word[this.language].asian}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/asianLarge.jpg"
              srcset="assets/images/foodTypes/asianSmall.jpg 992w, assets/images/foodTypes/asianLarge.jpg 2000w"
              alt="{{this.word[this.language].asian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].asian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].arabic}} {{this.word[this.language].kitchen}}"
         [routerLink]="'/' + language == 'en' ? language + '/' + 'arabska.kuhnia_42/1' : 'arabska.kuhnia_42/1'">

          <p class="food-category-title">{{this.word[this.language].arabic}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/arabicLarge.jpg"
              srcset="assets/images/foodTypes/arabicSmall.jpg 992w, assets/images/foodTypes/arabicLarge.jpg 2000w"
              alt="{{this.word[this.language].arabic}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].arabic}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].bulgarian}} {{this.word[this.language].kitchen}}"
         [routerLink]="'/' + language == 'en' ? language + '/' + 'balgarska.kuhnia_3/1' : 'balgarska.kuhnia_3/1'">
          <p class="food-category-title">{{this.word[this.language].bulgarian}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/bulgarianLarge.jpg"
              srcset="assets/images/foodTypes/bulgarianSmall.jpg 992w, assets/images/foodTypes/bulgarianLarge.jpg 2000w"
              alt="{{this.word[this.language].bulgarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].bulgarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].oriental}} {{this.word[this.language].kitchen}}"
         [routerLink]="'/' + language == 'en' ? language + '/' + 'iztochna.kuhnia_434/1' : 'iztochna.kuhnia_434/1'">

          <p class="food-category-title">{{this.word[this.language].oriental}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/easternLarge.jpg"
              srcset="assets/images/foodTypes/easternSmall.jpg 992w, assets/images/foodTypes/easternLarge.jpg 2000w"
              alt="{{this.word[this.language].oriental}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].oriental}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].sushi}} {{this.word[this.language].restaurants}}"
         [routerLink]="'/' + language == 'en' ? language + '/' + 'sushi.restoranti_166/1' : 'sushi.restoranti_166/1'">

          <p class="food-category-title">{{this.word[this.language].sushi}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/sushiLarge.jpg"
              srcset="assets/images/foodTypes/sushiSmall.jpg 992w, assets/images/foodTypes/sushiLarge.jpg 2000w"
              alt="{{this.word[this.language].sushi}} {{this.word[this.language].restaurants}}" title="{{this.word[this.language].sushi}} {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].mediterranean}} {{this.word[this.language].kitchen}}"
         [routerLink]="'/' + language == 'en' ? language + '/' + 'sredizemnomorska.kuhnia_181/1' : 'sredizemnomorska.kuhnia_181/1'">

          <p class="food-category-title">{{this.word[this.language].mediterranean}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/mediterranianLarge.jpg"
              srcset="assets/images/foodTypes/mediterranianSmall.jpg 992w, assets/images/foodTypes/mediterranianLarge.jpg 2000w"
              alt="{{this.word[this.language].mediterranean}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}"
              title="{{this.word[this.language].mediterranean}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].latin}} {{this.word[this.language].kitchen}}"
         [routerLink]="'/' + language == 'en' ? language + '/' + 'latino.amerikanska_217/1' : 'latino.amerikanska_217/1'">
          <p class="food-category-title">{{this.word[this.language].latin}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/latinAmericanLarge.jpg"
              srcset="assets/images/foodTypes/latinAmericanSmall.jpg 992w, assets/images/foodTypes/latinAmericanLarge.jpg 2000w"
              alt="{{this.word[this.language].latin}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].latin}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].streetFood}}"
         [routerLink]="'/' + language == 'en' ? language + '/' + 'street.food_433/1' : 'street.food_433/1'">

          <p class="food-category-title">{{this.word[this.language].streetFood}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/streetFoodLarge.jpg"
              srcset="assets/images/foodTypes/streetFoodSmall.jpg 992w, assets/images/foodTypes/streetFoodLarge.jpg 2000w"
              alt="{{this.word[this.language].streetFood}}, {{this.word[this.language].zavedenia}}" title="{{this.word[this.language].streetFood}}, {{this.word[this.language].zavedenia}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].burgers}}, {{this.word[this.language].zavedenia}}"
         [routerLink]="'/' + language == 'en' ? language + '/' + 'burgeri_355/1' : 'burgeri_355/1'">

          <p class="food-category-title">{{this.word[this.language].burgers}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/burgersLarge.jpg"
              srcset="assets/images/foodTypes/burgersSmall.jpg 992w, assets/images/foodTypes/burgersLarge.jpg 2000w"
              alt="{{this.word[this.language].burgers}}, {{this.word[this.language].zavedenia}}" title="{{this.word[this.language].burgers}}, {{this.word[this.language].zavedenia}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].vegetarian}} {{this.word[this.language].kitchen}}"
         [routerLink]="'/' + language == 'en' ? language + '/' + 'vegan.vegetarianska.kuhnia_426/1' : 'vegan.vegetarianska.kuhnia_426/1'">

          <p class="food-category-title">{{this.word[this.language].vegetarian}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/veganVegetarianLarge.jpg"
              srcset="assets/images/foodTypes/veganVegetarianSmall.jpg 992w, assets/images/foodTypes/veganVegetarianLarge.jpg 2000w"
              alt="{{this.word[this.language].vegetarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].vegetarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].indian}} {{this.word[this.language].kitchen}}"
         [routerLink]="'/' + language == 'en' ? language + '/' + 'indiiska.kuhnia_75/1' : 'indiiska.kuhnia_75/1'">

          <p class="food-category-title">{{this.word[this.language].indian}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/indianLarge.jpg"
              srcset="assets/images/foodTypes/indianSmall.jpg 992w, assets/images/foodTypes/indianLarge.jpg 2000w"
              alt="{{this.word[this.language].indian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].indian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].balkan}} {{this.word[this.language].kitchen}}"
         [routerLink]="'/' + language == 'en' ? language + '/' + 'balkanska.kuhnia_266/1' : 'balkanska.kuhnia_266/1'">

          <p class="food-category-title">{{this.word[this.language].balkan}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/balkanLarge.jpg"
              srcset="assets/images/foodTypes/balkanSmall.jpg 992w, assets/images/foodTypes/balkanLarge.jpg 2000w"
              srcset="assets/images/foodTypes/barbecueSmall.jpg 992w, assets/images/foodTypes/barbecueLarge.jpg 2000w"
              alt="{{this.word[this.language].balkan}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].balkan}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
</div>
<div class="new-section food-type" *ngIf="this.city == 'plovdiv'">

<div class="food-category-box">
    <a title="{{this.word[this.language].grill}}, {{this.word[this.language].zavedenia}}"
       [routerLink]="'/' + language == 'en' ? language + '/' + 'skara.bbq_150/1' : 'skara.bbq_150/1'">
        <p class="food-category-title">{{this.word[this.language].grill}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/barbecueLarge.jpg"
            srcset="assets/images/foodTypes/barbecueSmall.jpg 992w, assets/images/foodTypes/barbecueLarge.jpg 2000w"
            alt="{{this.word[this.language].grill}}, {{this.word[this.language].zavedenia}}" title="{{this.word[this.language].grill}}, {{this.word[this.language].zavedenia}}">
    </a>
</div>
<div class="food-category-box">
    <a title="{{this.word[this.language].italian}} {{this.word[this.language].kitchen}}"
       [routerLink]="'/' + language == 'en' ? language + '/' + 'italianska.kuhnia_17/1' : 'italianska.kuhnia_17/1'">
        <p class="food-category-title">{{this.word[this.language].italian}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/italianLarge.jpg"
            srcset="assets/images/foodTypes/italianSmall.jpg 992w, assets/images/foodTypes/italianLarge.jpg 2000w"
            alt="{{this.word[this.language].italian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].italian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
    </a>
</div>
<div class="food-category-box">
  <a title="{{this.word[this.language].sushi}} {{this.word[this.language].restaurants}}"
     [routerLink]="'/' + language == 'en' ? language + '/' + 'sushi.restoranti_308/1' : 'sushi.restoranti_308/1'">

      <p class="food-category-title">{{this.word[this.language].sushi}}</p>
      <img class="food-category-image" src="assets/images/foodTypes/sushiLarge.jpg"
          srcset="assets/images/foodTypes/sushiSmall.jpg 992w, assets/images/foodTypes/sushiLarge.jpg 2000w"
          alt="{{this.word[this.language].sushi}} {{this.word[this.language].restaurants}}" title="{{this.word[this.language].sushi}} {{this.word[this.language].restaurants}}">
  </a>
</div>
<div class="food-category-box">
  <a title="{{this.word[this.language].mediterranean}} {{this.word[this.language].kitchen}}"
     [routerLink]="'/' + language == 'en' ? language + '/' + 'sredizemnomorska.kuhnia_305/1' : 'sredizemnomorska.kuhnia_305/1'">

      <p class="food-category-title">{{this.word[this.language].mediterranean}}</p>
      <img class="food-category-image" src="assets/images/foodTypes/mediterranianLarge.jpg"
          srcset="assets/images/foodTypes/mediterranianSmall.jpg 992w, assets/images/foodTypes/mediterranianLarge.jpg 2000w"
          alt="{{this.word[this.language].mediterranean}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}"
          title="{{this.word[this.language].mediterranean}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
  </a>
</div>
<div class="food-category-box">
  <a title="{{this.word[this.language].fineDining}}, {{this.word[this.language].restaurants}}"
     [routerLink]="'/' + language == 'en' ? language + '/' + 'fine.dining_435/1' : 'fine.dining_435/1'">

      <p class="food-category-title">{{this.word[this.language].fineDining}}</p>
      <img class="food-category-image" src="assets/images/foodTypes/fineDiningLarge.jpg"
          srcset="assets/images/foodTypes/fineDiningSmall.jpg 992w, assets/images/foodTypes/fineDiningLarge.jpg 2000w"
          alt="{{this.word[this.language].fineDining}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].fineDining}}, {{this.word[this.language].restaurants}}">
  </a>
</div>
<div class="food-category-box">
  <a title="{{this.word[this.language].european}} {{this.word[this.language].kitchen}}"
     [routerLink]="'/' + language == 'en' ? language + '/' + 'evropeiska_15/1' : 'evropeiska_15/1'" >
      <p class="food-category-title">{{this.word[this.language].european}}</p>
      <img class="food-category-image" src="assets/images/foodTypes/europeanLarge.jpg"
          srcset="assets/images/foodTypes/europeanSmall.jpg 992w, assets/images/foodTypes/europeanLarge.jpg 2000w"
          alt="{{this.word[this.language].european}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].european}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
  </a>
</div>
<div class="food-category-box">
    <a title="{{this.word[this.language].arabic}} {{this.word[this.language].kitchen}}"
       [routerLink]="'/' + language == 'en' ? language + '/' + 'arabska.kuhnia_18/1' : 'arabska.kuhnia_18/1'">

        <p class="food-category-title">{{this.word[this.language].arabic}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/arabicLarge.jpg"
            srcset="assets/images/foodTypes/arabicSmall.jpg 992w, assets/images/foodTypes/arabicLarge.jpg 2000w"
            alt="{{this.word[this.language].arabic}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].arabic}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
    </a>
</div>
<div class="food-category-box">
    <a title="{{this.word[this.language].bulgarian}} {{this.word[this.language].kitchen}}"
       [routerLink]="'/' + language == 'en' ? language + '/' + 'balgarska.kuhnia_14/1' : 'balgarska.kuhnia_14/1'">
        <p class="food-category-title">{{this.word[this.language].bulgarian}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/bulgarianLarge.jpg"
            srcset="assets/images/foodTypes/bulgarianSmall.jpg 992w, assets/images/foodTypes/bulgarianLarge.jpg 2000w"
            alt="{{this.word[this.language].bulgarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].bulgarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
    </a>
</div>
<div class="food-category-box">
    <a title="{{this.word[this.language].turkishFood}} {{this.word[this.language].kitchen}}"
       [routerLink]="'/' + language == 'en' ? language + '/' + 'turkish.cuisine_80/1' : 'turkish.cuisine_80/1'">

        <p class="food-category-title">{{this.word[this.language].turkishFood}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/easternLarge.jpg"
            srcset="assets/images/foodTypes/easternSmall.jpg 992w, assets/images/foodTypes/easternLarge.jpg 2000w"
            alt="{{this.word[this.language].turkishFood}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].turkishFood}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
    </a>
</div>
<div class="food-category-box">
    <a title="{{this.word[this.language].fastFood}}"
       [routerLink]="'/' + language == 'en' ? language + '/' + 'fast.food_122/1' : 'fast.food_122/1'">

        <p class="food-category-title">{{this.word[this.language].fastFood}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/streetFoodLarge.jpg"
            srcset="assets/images/foodTypes/streetFoodSmall.jpg 992w, assets/images/foodTypes/streetFoodLarge.jpg 2000w"
            alt="{{this.word[this.language].fastFood}}, {{this.word[this.language].zavedenia}}" title="{{this.word[this.language].fastFood}}, {{this.word[this.language].zavedenia}}">
    </a>
</div>
<div class="food-category-box">
    <a title="{{this.word[this.language].burgers}}, {{this.word[this.language].zavedenia}}"
       [routerLink]="'/' + language == 'en' ? language + '/' + 'burgeri_429/1' : 'burgeri_429/1'">

        <p class="food-category-title">{{this.word[this.language].burgers}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/burgersLarge.jpg"
            srcset="assets/images/foodTypes/burgersSmall.jpg 992w, assets/images/foodTypes/burgersLarge.jpg 2000w"
            alt="{{this.word[this.language].burgers}}, {{this.word[this.language].zavedenia}}" title="{{this.word[this.language].burgers}}, {{this.word[this.language].zavedenia}}">
    </a>
</div>
<div class="food-category-box">
    <a title="{{this.word[this.language].vegetarian}} {{this.word[this.language].kitchen}}"
       [routerLink]="'/' + language == 'en' ? language + '/' + 'vegan.vegetarianska.kuhnia_430/1' : 'vegan.vegetarianska.kuhnia_430/1'">

        <p class="food-category-title">{{this.word[this.language].vegetarian}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/veganVegetarianLarge.jpg"
            srcset="assets/images/foodTypes/veganVegetarianSmall.jpg 992w, assets/images/foodTypes/veganVegetarianLarge.jpg 2000w"
            alt="{{this.word[this.language].vegetarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].vegetarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
    </a>
</div>
<div class="food-category-box">
    <a title="{{this.word[this.language].indian}} {{this.word[this.language].kitchen}}"
       [routerLink]="'/' + language == 'en' ? language + '/' + 'indiiska.kuhnia_312/1' : 'indiiska.kuhnia_312/1'">

        <p class="food-category-title">{{this.word[this.language].indian}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/indianLarge.jpg"
            srcset="assets/images/foodTypes/indianSmall.jpg 992w, assets/images/foodTypes/indianLarge.jpg 2000w"
            alt="{{this.word[this.language].indian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].indian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
    </a>
</div>
<div class="food-category-box">
    <a title="{{this.word[this.language].international}} {{this.word[this.language].kitchen}}"
       [routerLink]="'/' + language == 'en' ? language + '/' + 'internacionalna.kuhnia_140/1' : 'internacionalna.kuhnia_140/1'">

        <p class="food-category-title">{{this.word[this.language].international}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/internationalLarge.jpg"
            srcset="assets/images/foodTypes/internationalSmall.jpg 992w, assets/images/foodTypes/internationalLarge.jpg 2000w"
            srcset="assets/images/foodTypes/internationalSmall.jpg 992w, assets/images/foodTypes/internationalLarge.jpg 2000w"
            alt="{{this.word[this.language].international}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].international}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
    </a>
</div>
<div class="food-category-box">
  <a title="{{this.word[this.language].seafood}} {{this.word[this.language].kitchen}}"
     [routerLink]="'/' + language == 'en' ? language + '/' + 'morska.kuhnia_100/1' : 'morska.kuhnia_100/1'">
      <p class="food-category-title">{{this.word[this.language].seafood}}</p>
      <img class="food-category-image" src="assets/images/foodTypes/asianLarge.jpg"
          srcset="assets/images/foodTypes/seafoodSmall.jpg 992w, assets/images/foodTypes/seafoodLarge.jpg 2000w"
          alt="{{this.word[this.language].seafood}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].seafood}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
  </a>
</div>
<div class="food-category-box">
<a title="{{this.word[this.language].american}} {{this.word[this.language].kitchen}}"
   [routerLink]="'/' + language == 'en' ? language + '/' + 'amerikanska_22/1' : 'amerikanska_22/1'">
    <p class="food-category-title">{{this.word[this.language].american}}</p>
    <img class="food-category-image" src="assets/images/foodTypes/americanLarge.jpg"
        srcset="assets/images/foodTypes/americanSmall.jpg 992w, assets/images/foodTypes/americanLarge.jpg 2000w"
        alt="{{this.word[this.language].american}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].american}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
</a>
</div>
</div>
<div class="new-section food-type" *ngIf="this.city == 'varna'">

  <div class="food-category-box">
      <a title="{{this.word[this.language].grill}}, {{this.word[this.language].zavedenia}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'skara.bbq_66/1' : 'skara.bbq_66/1'">
          <p class="food-category-title">{{this.word[this.language].grill}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/barbecueLarge.jpg"
              srcset="assets/images/foodTypes/barbecueSmall.jpg 992w, assets/images/foodTypes/barbecueLarge.jpg 2000w"
              alt="{{this.word[this.language].grill}}, {{this.word[this.language].zavedenia}}" title="{{this.word[this.language].grill}}, {{this.word[this.language].zavedenia}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].italian}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'italianska.kuhnia_46/1' : 'italianska.kuhnia_46/1'">
          <p class="food-category-title">{{this.word[this.language].italian}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/italianLarge.jpg"
              srcset="assets/images/foodTypes/italianSmall.jpg 992w, assets/images/foodTypes/italianLarge.jpg 2000w"
              alt="{{this.word[this.language].italian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].italian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>

<div class="food-category-box">
    <a title="{{this.word[this.language].greek}} {{this.word[this.language].kitchen}}"
        [routerLink]="'/' + language == 'en' ? language + '/' + 'grucka.kuhnia_44/1' : 'grucka.kuhnia_44/1'">

        <p class="food-category-title">{{this.word[this.language].greek}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/mediterranianLarge.jpg"
            srcset="assets/images/foodTypes/mediterranianSmall.jpg 992w, assets/images/foodTypes/mediterranianLarge.jpg 2000w"
            alt="{{this.word[this.language].greek}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}"
            title="{{this.word[this.language].greek}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
    </a>
</div>

<div class="food-category-box">
    <a title="{{this.word[this.language].european}} {{this.word[this.language].kitchen}}"
        [routerLink]="'/' + language == 'en' ? language + '/' + 'evropeiska_54/1' : 'evropeiska_54/1'" >
        <p class="food-category-title">{{this.word[this.language].european}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/europeanLarge.jpg"
            srcset="assets/images/foodTypes/europeanSmall.jpg 992w, assets/images/foodTypes/europeanLarge.jpg 2000w"
            alt="{{this.word[this.language].european}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].european}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
    </a>
</div>

  <div class="food-category-box">
      <a title="{{this.word[this.language].bulgarian}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'balgarska.kuhnia_3/1' : 'balgarska.kuhnia_3/1'">
          <p class="food-category-title">{{this.word[this.language].bulgarian}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/bulgarianLarge.jpg"
              srcset="assets/images/foodTypes/bulgarianSmall.jpg 992w, assets/images/foodTypes/bulgarianLarge.jpg 2000w"
              alt="{{this.word[this.language].bulgarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].bulgarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].turkishFood}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'turkish.cuisine_80/1' : 'turkish.cuisine_80/1'">

          <p class="food-category-title">{{this.word[this.language].turkishFood}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/easternLarge.jpg"
              srcset="assets/images/foodTypes/easternSmall.jpg 992w, assets/images/foodTypes/easternLarge.jpg 2000w"
              alt="{{this.word[this.language].turkishFood}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].turkishFood}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
    <a title="{{this.word[this.language].fineDining}}, {{this.word[this.language].restaurants}}"
        [routerLink]="'/' + language == 'en' ? language + '/' + 'fine.dining_435/1' : 'fine.dining_435/1'">

        <p class="food-category-title">{{this.word[this.language].fineDining}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/fineDiningLarge.jpg"
            srcset="assets/images/foodTypes/fineDiningSmall.jpg 992w, assets/images/foodTypes/fineDiningLarge.jpg 2000w"
            alt="{{this.word[this.language].fineDining}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].fineDining}}, {{this.word[this.language].restaurants}}">
    </a>
</div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].fastFood}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'fast.food_74/1' : 'fast.food_74/1'">

          <p class="food-category-title">{{this.word[this.language].fastFood}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/streetFoodLarge.jpg"
              srcset="assets/images/foodTypes/streetFoodSmall.jpg 992w, assets/images/foodTypes/streetFoodLarge.jpg 2000w"
              alt="{{this.word[this.language].fastFood}}, {{this.word[this.language].zavedenia}}" title="{{this.word[this.language].fastFood}}, {{this.word[this.language].zavedenia}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].burgers}}, {{this.word[this.language].zavedenia}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'burgeri_374/1' : 'burgeri_374/1'">

          <p class="food-category-title">{{this.word[this.language].burgers}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/burgersLarge.jpg"
              srcset="assets/images/foodTypes/burgersSmall.jpg 992w, assets/images/foodTypes/burgersLarge.jpg 2000w"
              alt="{{this.word[this.language].burgers}}, {{this.word[this.language].zavedenia}}" title="{{this.word[this.language].burgers}}, {{this.word[this.language].zavedenia}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].vegetarian}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'vegan.vegetarianska.kuhnia_77/1' : 'vegan.vegetarianska.kuhnia_77/1'">

          <p class="food-category-title">{{this.word[this.language].vegetarian}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/veganVegetarianLarge.jpg"
              srcset="assets/images/foodTypes/veganVegetarianSmall.jpg 992w, assets/images/foodTypes/veganVegetarianLarge.jpg 2000w"
              alt="{{this.word[this.language].vegetarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].vegetarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].indian}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'indiiska.kuhnia_75/1' : 'indiiska.kuhnia_75/1'">

          <p class="food-category-title">{{this.word[this.language].indian}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/indianLarge.jpg"
              srcset="assets/images/foodTypes/indianSmall.jpg 992w, assets/images/foodTypes/indianLarge.jpg 2000w"
              alt="{{this.word[this.language].indian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].indian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].international}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'internacionalna.kuhnia_70/1' : 'internacionalna.kuhnia_70/1'">

          <p class="food-category-title">{{this.word[this.language].international}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/internationalLarge.jpg"
              srcset="assets/images/foodTypes/internationalSmall.jpg 992w, assets/images/foodTypes/internationalLarge.jpg 2000w"
              srcset="assets/images/foodTypes/internationalSmall.jpg 992w, assets/images/foodTypes/internationalLarge.jpg 2000w"
              alt="{{this.word[this.language].international}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].international}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
    <a title="{{this.word[this.language].seafood}} {{this.word[this.language].kitchen}}"
        [routerLink]="'/' + language == 'en' ? language + '/' + 'morska.kuhnia_131/1' : 'morska.kuhnia_131/1'">
        <p class="food-category-title">{{this.word[this.language].seafood}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/asianLarge.jpg"
            srcset="assets/images/foodTypes/seafoodSmall.jpg 992w, assets/images/foodTypes/seafoodLarge.jpg 2000w"
            alt="{{this.word[this.language].seafood}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].seafood}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
    </a>
</div>
<div class="food-category-box">
  <a title="{{this.word[this.language].arabic}} {{this.word[this.language].kitchen}}"
      [routerLink]="'/' + language == 'en' ? language + '/' + 'arabska.kuhnia_42/1' : 'arabska.kuhnia_42/1'">

      <p class="food-category-title">{{this.word[this.language].arabic}}</p>
      <img class="food-category-image" src="assets/images/foodTypes/arabicLarge.jpg"
          srcset="assets/images/foodTypes/arabicSmall.jpg 992w, assets/images/foodTypes/arabicLarge.jpg 2000w"
          alt="{{this.word[this.language].arabic}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].arabic}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
  </a>
</div>
<div class="food-category-box">
<a title="{{this.word[this.language].american}} {{this.word[this.language].kitchen}}"
    [routerLink]="'/' + language == 'en' ? language + '/' + 'amerikanska_43/1' : 'amerikanska_43/1'">
    <p class="food-category-title">{{this.word[this.language].american}}</p>
    <img class="food-category-image" src="assets/images/foodTypes/americanLarge.jpg"
        srcset="assets/images/foodTypes/americanSmall.jpg 992w, assets/images/foodTypes/americanLarge.jpg 2000w"
        alt="{{this.word[this.language].american}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].american}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
</a>
</div>
<div class="food-category-box">
<a title="{{this.word[this.language].japanese}} {{this.word[this.language].restaurants}}"
    [routerLink]="'/' + language == 'en' ? language + '/' + 'qponska_112/1' : 'qponska_112/1'">

    <p class="food-category-title">{{this.word[this.language].japanese}}</p>
    <img class="food-category-image" src="assets/images/foodTypes/sushiLarge.jpg"
        srcset="assets/images/foodTypes/sushiSmall.jpg 992w, assets/images/foodTypes/sushiLarge.jpg 2000w"
        alt="{{this.word[this.language].japanese}} {{this.word[this.language].restaurants}}" title="{{this.word[this.language].japanese}} {{this.word[this.language].restaurants}}">
</a>
</div>

</div>
<div class="new-section food-type" *ngIf="this.city == 'skopje'">
  <div class="food-category-box">
      <a title="{{this.word[this.language].grill}}, {{this.word[this.language].zavedenia}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'barbeque_66/1' : 'barbeque_66/1'">
          <p class="food-category-title">{{this.word[this.language].grill}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/barbecueLarge.jpg"
              srcset="assets/images/foodTypes/barbecueSmall.jpg 992w, assets/images/foodTypes/barbecueLarge.jpg 2000w"
              alt="{{this.word[this.language].grill}}, {{this.word[this.language].zavedenia}}" title="{{this.word[this.language].grill}}, {{this.word[this.language].zavedenia}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].italian}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'italianska.kuhnia_46/1' : 'italianska.kuhnia_46/1'">
          <p class="food-category-title">{{this.word[this.language].italian}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/italianLarge.jpg"
              srcset="assets/images/foodTypes/italianSmall.jpg 992w, assets/images/foodTypes/italianLarge.jpg 2000w"
              alt="{{this.word[this.language].italian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].italian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>

<div class="food-category-box">
    <a title="{{this.word[this.language].greek}} {{this.word[this.language].kitchen}}"
        [routerLink]="'/' + language == 'en' ? language + '/' + 'grucka.kuhnia_44/1' : 'grucka.kuhnia_44/1'">

        <p class="food-category-title">{{this.word[this.language].greek}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/mediterranianLarge.jpg"
            srcset="assets/images/foodTypes/mediterranianSmall.jpg 992w, assets/images/foodTypes/mediterranianLarge.jpg 2000w"
            alt="{{this.word[this.language].greek}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}"
            title="{{this.word[this.language].greek}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
    </a>
</div>

<div class="food-category-box">
    <a title="{{this.word[this.language].european}} {{this.word[this.language].kitchen}}"
        [routerLink]="'/' + language == 'en' ? language + '/' + 'european_54/1' : 'european_54/1'" >
        <p class="food-category-title">{{this.word[this.language].european}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/europeanLarge.jpg"
            srcset="assets/images/foodTypes/europeanSmall.jpg 992w, assets/images/foodTypes/europeanLarge.jpg 2000w"
            alt="{{this.word[this.language].european}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].european}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
    </a>
</div>

  <div class="food-category-box">
      <a title="{{this.word[this.language].bulgarian}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'bulgarian.cuisine/1' : 'bulgarian.cuisine/1'">
          <p class="food-category-title">{{this.word[this.language].bulgarian}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/bulgarianLarge.jpg"
              srcset="assets/images/foodTypes/bulgarianSmall.jpg 992w, assets/images/foodTypes/bulgarianLarge.jpg 2000w"
              alt="{{this.word[this.language].bulgarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].bulgarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].turkishFood}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'turkish.cuisine_80/1' : 'turkish.cuisine_80/1'">

          <p class="food-category-title">{{this.word[this.language].turkishFood}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/easternLarge.jpg"
              srcset="assets/images/foodTypes/easternSmall.jpg 992w, assets/images/foodTypes/easternLarge.jpg 2000w"
              alt="{{this.word[this.language].turkishFood}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].turkishFood}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
    <a title="{{this.word[this.language].fineDining}}, {{this.word[this.language].restaurants}}"
        [routerLink]="'/' + language == 'en' ? language + '/' + 'fine.dining_435/1' : 'fine.dining_435/1'">

        <p class="food-category-title">{{this.word[this.language].fineDining}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/fineDiningLarge.jpg"
            srcset="assets/images/foodTypes/fineDiningSmall.jpg 992w, assets/images/foodTypes/fineDiningLarge.jpg 2000w"
            alt="{{this.word[this.language].fineDining}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].fineDining}}, {{this.word[this.language].restaurants}}">
    </a>
</div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].fastFood}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'fast.food_74/1' : 'fast.food_74/1'">

          <p class="food-category-title">{{this.word[this.language].fastFood}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/streetFoodLarge.jpg"
              srcset="assets/images/foodTypes/streetFoodSmall.jpg 992w, assets/images/foodTypes/streetFoodLarge.jpg 2000w"
              alt="{{this.word[this.language].fastFood}}, {{this.word[this.language].zavedenia}}" title="{{this.word[this.language].fastFood}}, {{this.word[this.language].zavedenia}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].burgers}}, {{this.word[this.language].zavedenia}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'burgeri_374/1' : 'burgeri_374/1'">

          <p class="food-category-title">{{this.word[this.language].burgers}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/burgersLarge.jpg"
              srcset="assets/images/foodTypes/burgersSmall.jpg 992w, assets/images/foodTypes/burgersLarge.jpg 2000w"
              alt="{{this.word[this.language].burgers}}, {{this.word[this.language].zavedenia}}" title="{{this.word[this.language].burgers}}, {{this.word[this.language].zavedenia}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].vegetarian}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'vegan.vegetarianska.kuhnia_77/1' : 'vegan.vegetarianska.kuhnia_77/1'">

          <p class="food-category-title">{{this.word[this.language].vegetarian}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/veganVegetarianLarge.jpg"
              srcset="assets/images/foodTypes/veganVegetarianSmall.jpg 992w, assets/images/foodTypes/veganVegetarianLarge.jpg 2000w"
              alt="{{this.word[this.language].vegetarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].vegetarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].indian}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'indiiska.kuhnia_75/1' : 'indiiska.kuhnia_75/1'">

          <p class="food-category-title">{{this.word[this.language].indian}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/indianLarge.jpg"
              srcset="assets/images/foodTypes/indianSmall.jpg 992w, assets/images/foodTypes/indianLarge.jpg 2000w"
              alt="{{this.word[this.language].indian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].indian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].international}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'internacionalna.kuhnia_70/1' : 'internacionalna.kuhnia_70/1'">

          <p class="food-category-title">{{this.word[this.language].international}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/internationalLarge.jpg"
              srcset="assets/images/foodTypes/internationalSmall.jpg 992w, assets/images/foodTypes/internationalLarge.jpg 2000w"
              srcset="assets/images/foodTypes/internationalSmall.jpg 992w, assets/images/foodTypes/internationalLarge.jpg 2000w"
              alt="{{this.word[this.language].international}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].international}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
    <a title="{{this.word[this.language].seafood}} {{this.word[this.language].kitchen}}"
        [routerLink]="'/' + language == 'en' ? language + '/' + 'morska.kuhnia_131/1' : 'morska.kuhnia_131/1'">
        <p class="food-category-title">{{this.word[this.language].seafood}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/asianLarge.jpg"
            srcset="assets/images/foodTypes/seafoodSmall.jpg 992w, assets/images/foodTypes/seafoodLarge.jpg 2000w"
            alt="{{this.word[this.language].seafood}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].seafood}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
    </a>
</div>
<div class="food-category-box">
  <a title="{{this.word[this.language].arabic}} {{this.word[this.language].kitchen}}"
      [routerLink]="'/' + language == 'en' ? language + '/' + 'arabska.kuhnia_42/1' : 'arabska.kuhnia_42/1'">

      <p class="food-category-title">{{this.word[this.language].arabic}}</p>
      <img class="food-category-image" src="assets/images/foodTypes/arabicLarge.jpg"
          srcset="assets/images/foodTypes/arabicSmall.jpg 992w, assets/images/foodTypes/arabicLarge.jpg 2000w"
          alt="{{this.word[this.language].arabic}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].arabic}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
  </a>
</div>
<div class="food-category-box">
<a title="{{this.word[this.language].american}} {{this.word[this.language].kitchen}}"
    [routerLink]="'/' + language == 'en' ? language + '/' + 'amerikanska_43/1' : 'amerikanska_43/1'">
    <p class="food-category-title">{{this.word[this.language].american}}</p>
    <img class="food-category-image" src="assets/images/foodTypes/americanLarge.jpg"
        srcset="assets/images/foodTypes/americanSmall.jpg 992w, assets/images/foodTypes/americanLarge.jpg 2000w"
        alt="{{this.word[this.language].american}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].american}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
</a>
</div>
<div class="food-category-box">
<a title="{{this.word[this.language].japanese}} {{this.word[this.language].restaurants}}"
    [routerLink]="'/' + language == 'en' ? language + '/' + 'qponska_112/1' : 'qponska_112/1'">

    <p class="food-category-title">{{this.word[this.language].japanese}}</p>
    <img class="food-category-image" src="assets/images/foodTypes/sushiLarge.jpg"
        srcset="assets/images/foodTypes/sushiSmall.jpg 992w, assets/images/foodTypes/sushiLarge.jpg 2000w"
        alt="{{this.word[this.language].japanese}} {{this.word[this.language].restaurants}}" title="{{this.word[this.language].japanese}} {{this.word[this.language].restaurants}}">
</a>
</div>

</div>
<div class="new-section food-type" *ngIf="this.city== 'beograd'">
  <div class="food-category-box">
      <a title="{{this.word[this.language].grill}}, {{this.word[this.language].zavedenia}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'skara.bbq_66/1' : 'skara.bbq_66/1'">
          <p class="food-category-title">{{this.word[this.language].grill}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/barbecueLarge.jpg"
              srcset="assets/images/foodTypes/barbecueSmall.jpg 992w, assets/images/foodTypes/barbecueLarge.jpg 2000w"
              alt="{{this.word[this.language].grill}}, {{this.word[this.language].zavedenia}}" title="{{this.word[this.language].grill}}, {{this.word[this.language].zavedenia}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].italian}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'italianska.kuhnia_46/1' : 'italianska.kuhnia_46/1'">
          <p class="food-category-title">{{this.word[this.language].italian}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/italianLarge.jpg"
              srcset="assets/images/foodTypes/italianSmall.jpg 992w, assets/images/foodTypes/italianLarge.jpg 2000w"
              alt="{{this.word[this.language].italian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].italian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>

<div class="food-category-box">
    <a title="{{this.word[this.language].greek}} {{this.word[this.language].kitchen}}"
        [routerLink]="'/' + language == 'en' ? language + '/' + 'grucka.kuhnia_44/1' : 'grucka.kuhnia_44/1'">

        <p class="food-category-title">{{this.word[this.language].greek}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/mediterranianLarge.jpg"
            srcset="assets/images/foodTypes/mediterranianSmall.jpg 992w, assets/images/foodTypes/mediterranianLarge.jpg 2000w"
            alt="{{this.word[this.language].greek}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}"
            title="{{this.word[this.language].greek}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
    </a>
</div>

<div class="food-category-box">
    <a title="{{this.word[this.language].european}} {{this.word[this.language].kitchen}}"
        [routerLink]="'/' + language == 'en' ? language + '/' + 'evropeiska_54/1' : 'evropeiska_54/1'" >
        <p class="food-category-title">{{this.word[this.language].european}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/europeanLarge.jpg"
            srcset="assets/images/foodTypes/europeanSmall.jpg 992w, assets/images/foodTypes/europeanLarge.jpg 2000w"
            alt="{{this.word[this.language].european}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].european}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
    </a>
</div>

  <div class="food-category-box">
      <a title="{{this.word[this.language].bulgarian}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'balgarska.kuhnia_3/1' : 'balgarska.kuhnia_3/1'">
          <p class="food-category-title">{{this.word[this.language].bulgarian}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/bulgarianLarge.jpg"
              srcset="assets/images/foodTypes/bulgarianSmall.jpg 992w, assets/images/foodTypes/bulgarianLarge.jpg 2000w"
              alt="{{this.word[this.language].bulgarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].bulgarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].turkishFood}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'turkish.cuisine_80/1' : 'turkish.cuisine_80/1'">

          <p class="food-category-title">{{this.word[this.language].turkishFood}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/easternLarge.jpg"
              srcset="assets/images/foodTypes/easternSmall.jpg 992w, assets/images/foodTypes/easternLarge.jpg 2000w"
              alt="{{this.word[this.language].turkishFood}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].turkishFood}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
    <a title="{{this.word[this.language].fineDining}}, {{this.word[this.language].restaurants}}"
        [routerLink]="'/' + language == 'en' ? language + '/' + 'fine.dining_435/1' : 'fine.dining_435/1'">

        <p class="food-category-title">{{this.word[this.language].fineDining}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/fineDiningLarge.jpg"
            srcset="assets/images/foodTypes/fineDiningSmall.jpg 992w, assets/images/foodTypes/fineDiningLarge.jpg 2000w"
            alt="{{this.word[this.language].fineDining}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].fineDining}}, {{this.word[this.language].restaurants}}">
    </a>
</div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].fastFood}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'fast.food_74/1' : 'fast.food_74/1'">

          <p class="food-category-title">{{this.word[this.language].fastFood}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/streetFoodLarge.jpg"
              srcset="assets/images/foodTypes/streetFoodSmall.jpg 992w, assets/images/foodTypes/streetFoodLarge.jpg 2000w"
              alt="{{this.word[this.language].fastFood}}, {{this.word[this.language].zavedenia}}" title="{{this.word[this.language].fastFood}}, {{this.word[this.language].zavedenia}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].burgers}}, {{this.word[this.language].zavedenia}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'burgeri_374/1' : 'burgeri_374/1'">

          <p class="food-category-title">{{this.word[this.language].burgers}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/burgersLarge.jpg"
              srcset="assets/images/foodTypes/burgersSmall.jpg 992w, assets/images/foodTypes/burgersLarge.jpg 2000w"
              alt="{{this.word[this.language].burgers}}, {{this.word[this.language].zavedenia}}" title="{{this.word[this.language].burgers}}, {{this.word[this.language].zavedenia}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].vegetarian}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'vegan.vegetarianska.kuhnia_77/1' : 'vegan.vegetarianska.kuhnia_77/1'">

          <p class="food-category-title">{{this.word[this.language].vegetarian}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/veganVegetarianLarge.jpg"
              srcset="assets/images/foodTypes/veganVegetarianSmall.jpg 992w, assets/images/foodTypes/veganVegetarianLarge.jpg 2000w"
              alt="{{this.word[this.language].vegetarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].vegetarian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].indian}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'indiiska.kuhnia_75/1' : 'indiiska.kuhnia_75/1'">

          <p class="food-category-title">{{this.word[this.language].indian}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/indianLarge.jpg"
              srcset="assets/images/foodTypes/indianSmall.jpg 992w, assets/images/foodTypes/indianLarge.jpg 2000w"
              alt="{{this.word[this.language].indian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].indian}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
      <a title="{{this.word[this.language].international}} {{this.word[this.language].kitchen}}"
          [routerLink]="'/' + language == 'en' ? language + '/' + 'internacionalna.kuhnia_70/1' : 'internacionalna.kuhnia_70/1'">

          <p class="food-category-title">{{this.word[this.language].international}}</p>
          <img class="food-category-image" src="assets/images/foodTypes/internationalLarge.jpg"
              srcset="assets/images/foodTypes/internationalSmall.jpg 992w, assets/images/foodTypes/internationalLarge.jpg 2000w"
              srcset="assets/images/foodTypes/internationalSmall.jpg 992w, assets/images/foodTypes/internationalLarge.jpg 2000w"
              alt="{{this.word[this.language].international}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].international}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
      </a>
  </div>
  <div class="food-category-box">
    <a title="{{this.word[this.language].seafood}} {{this.word[this.language].kitchen}}"
        [routerLink]="'/' + language == 'en' ? language + '/' + 'morska.kuhnia_131/1' : 'morska.kuhnia_131/1'">
        <p class="food-category-title">{{this.word[this.language].seafood}}</p>
        <img class="food-category-image" src="assets/images/foodTypes/asianLarge.jpg"
            srcset="assets/images/foodTypes/seafoodSmall.jpg 992w, assets/images/foodTypes/seafoodLarge.jpg 2000w"
            alt="{{this.word[this.language].seafood}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].seafood}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
    </a>
</div>
<div class="food-category-box">
  <a title="{{this.word[this.language].arabic}} {{this.word[this.language].kitchen}}"
      [routerLink]="'/' + language == 'en' ? language + '/' + 'arabska.kuhnia_42/1' : 'arabska.kuhnia_42/1'">

      <p class="food-category-title">{{this.word[this.language].arabic}}</p>
      <img class="food-category-image" src="assets/images/foodTypes/arabicLarge.jpg"
          srcset="assets/images/foodTypes/arabicSmall.jpg 992w, assets/images/foodTypes/arabicLarge.jpg 2000w"
          alt="{{this.word[this.language].arabic}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].arabic}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
  </a>
</div>
<div class="food-category-box">
<a title="{{this.word[this.language].american}} {{this.word[this.language].kitchen}}"
    [routerLink]="'/' + language == 'en' ? language + '/' + 'amerikanska_43/1' : 'amerikanska_43/1'">
    <p class="food-category-title">{{this.word[this.language].american}}</p>
    <img class="food-category-image" src="assets/images/foodTypes/americanLarge.jpg"
        srcset="assets/images/foodTypes/americanSmall.jpg 992w, assets/images/foodTypes/americanLarge.jpg 2000w"
        alt="{{this.word[this.language].american}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}" title="{{this.word[this.language].american}} {{this.word[this.language].kitchen}}, {{this.word[this.language].restaurants}}">
</a>
</div>
<div class="food-category-box">
<a title="{{this.word[this.language].japanese}} {{this.word[this.language].restaurants}}"
    [routerLink]="'/' + language == 'en' ? language + '/' + 'qponska_112/1' : 'qponska_112/1'">

    <p class="food-category-title">{{this.word[this.language].japanese}}</p>
    <img class="food-category-image" src="assets/images/foodTypes/sushiLarge.jpg"
        srcset="assets/images/foodTypes/sushiSmall.jpg 992w, assets/images/foodTypes/sushiLarge.jpg 2000w"
        alt="{{this.word[this.language].japanese}} {{this.word[this.language].restaurants}}" title="{{this.word[this.language].japanese}} {{this.word[this.language].restaurants}}">
</a>
</div>

</div>
  </div>
</div>
